/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module NvcplpluginTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface NvCplplugin {
    [k: string]: any;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ProfileSetting".
 */
export interface ProfileSetting {
    SettingType?: ProfileSettingType;
    /**
     * setting enum needs to used in communicating with backend
     */
    enumId?: number;
    /**
     * DRS enum id to map this setting to ops setting
     */
    drsEnumId?: string;
    /**
     * setting is supported or not
     */
    isSupported?: boolean;
    hwSupport?: HwSupportType;
    /**
     * setting possible values are dynamic or not
     */
    isDynamic?: boolean;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "TextureFilteringTrilinearData".
 */
export interface TextureFilteringTrilinearData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "CudaGpusData".
 */
export interface CudaGpusData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "CudaGpuOrderingData".
 */
export interface CudaGpuOrderingData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "VerticalSyncData".
 */
export interface VerticalSyncData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "TexturefilteringAnisotropicFilterOptData".
 */
export interface TexturefilteringAnisotropicFilterOptData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "TexturefilteringAnisotropicSampleOptData".
 */
export interface TexturefilteringAnisotropicSampleOptData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "TripleBufferingData".
 */
export interface TripleBufferingData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "MultiFrameSampleAAData".
 */
export interface MultiFrameSampleAAData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "AntialiasingFXAAData".
 */
export interface AntialiasingFXAAData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "AntialiasingGammaCorrectionData".
 */
export interface AntialiasingGammaCorrectionData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GpuScalingData".
 */
export interface GpuScalingData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ThreadedOptimizationData".
 */
export interface ThreadedOptimizationData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "EnableOverlayData".
 */
export interface EnableOverlayData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ExportedpixeltypesData".
 */
export interface ExportedpixeltypesData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ShaderCacheData".
 */
export interface ShaderCacheData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "PreCompileShaderData".
 */
export interface PreCompileShaderData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "VirtualRealityPreRenderedFramesData".
 */
export interface VirtualRealityPreRenderedFramesData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "PreferredRefreshRateData".
 */
export interface PreferredRefreshRateData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "PowerManagementModeData".
 */
export interface PowerManagementModeData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "OpenGlVulkanPresentMethodData".
 */
export interface OpenGlVulkanPresentMethodData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "CudaSysmemFallbackPolicyData".
 */
export interface CudaSysmemFallbackPolicyData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ResizableBarData".
 */
export interface ResizableBarData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "OpenGlGdiCompatibilityData".
 */
export interface OpenGlGdiCompatibilityData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "AnisotropicFilteringData".
 */
export interface AnisotropicFilteringData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "TextureFilteringNegativeMethodData".
 */
export interface TextureFilteringNegativeMethodData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "TextureFilteringQualityData".
 */
export interface TextureFilteringQualityData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "OpenGLRenderingGPUData".
 */
export interface OpenGLRenderingGPUData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ImageSharpeningToggleData".
 */
export interface ImageSharpeningToggleData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ImageSharpeningAllowData".
 */
export interface ImageSharpeningAllowData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ImageSharpeningNoiseGrainData".
 */
export interface ImageSharpeningNoiseGrainData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ImageSharpeningData".
 */
export interface ImageSharpeningData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "MaxFrameRateData".
 */
export interface MaxFrameRateData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "MaxFrameRateFPSData".
 */
export interface MaxFrameRateFPSData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "BackgroundAppMaxFrameRateData".
 */
export interface BackgroundAppMaxFrameRateData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "BackgroundAppMaxFrameRateFPSData".
 */
export interface BackgroundAppMaxFrameRateFPSData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "WhisperModeProgramData".
 */
export interface WhisperModeProgramData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "SilkSmoothnessData".
 */
export interface SilkSmoothnessData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "LowLatencyModeData".
 */
export interface LowLatencyModeData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "VirtualRealityVrssData".
 */
export interface VirtualRealityVrssData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "MaxqDynamicBoostData".
 */
export interface MaxqDynamicBoostData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "AutoDisplaySwitchingData".
 */
export interface AutoDisplaySwitchingData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "WhisperModeGlobalData".
 */
export interface WhisperModeGlobalData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "MonitorTechnologyData".
 */
export interface MonitorTechnologyData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "PowerManagementPanelData".
 */
export interface PowerManagementPanelData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "StereoEnableData".
 */
export interface StereoEnableData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "StereoDisplayModeData".
 */
export interface StereoDisplayModeData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "StereoSwapEyeData".
 */
export interface StereoSwapEyeData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "StereoSwapModeData".
 */
export interface StereoSwapModeData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "AntialiasingModeData".
 */
export interface AntialiasingModeData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "SLIMultiGPURenderingModeData".
 */
export interface SLIMultiGPURenderingModeData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "DeepColorFor3DApplicationsData".
 */
export interface DeepColorFor3DApplicationsData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "AntialiasingSettingData".
 */
export interface AntialiasingSettingData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "AntialiasingTransparencyData".
 */
export interface AntialiasingTransparencyData {
    SettingInfo?: ProfileSetting;
}
/**
 * BatteryBoost Value
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "BatteryBoostValue".
 */
export interface BatteryBoostValue {
    version?: BatteryBoostVersionEnum;
    enabled?: boolean;
    /**
     * Frame rate - V1: Frame rate limit, V2: NA
     */
    frameRate?: number;
}
/**
 * WhisperMode Value
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "WhisperModeValue".
 */
export interface WhisperModeValue {
    version?: WhisperModeVersionEnum;
    enabled?: boolean;
    /**
     * Frame rate - V1: Frame rate limit, V2: Minimum frame rate.
     */
    frameRate?: number;
    fanVolume?: FanVolume;
}
/**
 * Enabled value with drs enum id
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ExtendedEnabledValue".
 */
export interface ExtendedEnabledValue {
    /**
     * DRS enum id to map this setting to ops setting
     */
    drsEnumId: string;
    value: boolean;
}
/**
 * Performance Mode Override with drs enum id
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ExtendedPerformanceModeOverride".
 */
export interface ExtendedPerformanceModeOverride {
    /**
     * DRS enum id to map this setting to ops setting
     */
    drsEnumId: string;
    value: PerformanceModeOverrideEnum;
}
/**
 * Scaling setting with drs enum id
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ExtendedScalingValue".
 */
export interface ExtendedScalingValue {
    /**
     * DRS enum id to map this setting to ops setting
     */
    drsEnumId: string;
    value: number;
}
/**
 * Model override with drs enum id
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ExtendedModelOverride".
 */
export interface ExtendedModelOverride {
    /**
     * DRS enum id to map this setting to ops setting
     */
    drsEnumId: string;
    value: ModelOverrideEnum;
}
/**
 * FG UIR model override with drs enum id
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ExtendedFGUIRModelOverride".
 */
export interface ExtendedFGUIRModelOverride {
    /**
     * DRS enum id to map this setting to ops setting
     */
    drsEnumId: string;
    value: FguirModelOverrideEnum;
}
/**
 * Multi frame count with drs enum id
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ExtendedMultiFrameCount".
 */
export interface ExtendedMultiFrameCount {
    /**
     * DRS enum id to map this setting to ops setting
     */
    drsEnumId: string;
    value: MultiFrameEnum;
}
/**
 * DLSS Model Preset Profile Type with drs enum id
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ExtendedDLSSModelPresetProfileType".
 */
export interface ExtendedDLSSModelPresetProfileType {
    /**
     * DRS enum id to map this setting to ops setting
     */
    drsEnumId: string;
    value: DlssModelPresetProfileTypeEnum;
}
/**
 * Dynamic FG Mode with drs enum id
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ExtendedDynamicFGMode".
 */
export interface ExtendedDynamicFGMode {
    /**
     * DRS enum id to map this setting to ops setting
     */
    drsEnumId: string;
    value: DynamicFgModeEnum;
}
/**
 * Dynamic FG Target Frame Rate with drs enum id
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ExtendedDynamicFGTargetFrameRate".
 */
export interface ExtendedDynamicFGTargetFrameRate {
    /**
     * DRS enum id to map this setting to ops setting
     */
    drsEnumId: string;
    value: number;
}
/**
 * DLSS Super Resolution Overrides Value
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "DLSSSRValue".
 */
export interface DLSSSRValue {
    enabled: ExtendedEnabledValue;
    supportState: DlssSupportState;
    performanceModeOverride: ExtendedPerformanceModeOverride;
    scaling: ExtendedScalingValue;
    modelOverride: ExtendedModelOverride;
    useGlobal?: boolean;
}
/**
 * DLSS Ray reconstuction Overrides Value
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "DLSSRRValue".
 */
export interface DLSSRRValue {
    enabled: ExtendedEnabledValue;
    supportState: DlssSupportState;
    performanceModeOverride: ExtendedPerformanceModeOverride;
    scaling: ExtendedScalingValue;
    modelOverride: ExtendedModelOverride;
    useGlobal?: boolean;
}
/**
 * DLSS Frame Generation Overrides Value
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "DLSSFGValue".
 */
export interface DLSSFGValue {
    enabled: ExtendedEnabledValue;
    supportState: DlssSupportState;
    multiFrameCount: ExtendedMultiFrameCount;
    useGlobal?: boolean;
    modelOverride?: ExtendedFGUIRModelOverride;
    dynamicFGMode?: ExtendedDynamicFGMode;
    dynamicFGTargetFrameRate?: ExtendedDynamicFGTargetFrameRate;
    dynamicFGMultiFrameCount?: ExtendedMultiFrameCount;
    slVersion?: string;
}
/**
 * missing 'useGlobal' means profile value should be used otherwise useGlobal must be always true. useGlobal with false is undefined behavior.
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "FGXValue".
 */
export interface FGXValue {
    enabled?: ExtendedEnabledValue;
    useGlobal?: boolean;
    /**
     * Array of supported Graphics API
     */
    allowedGfxApi?: GraphicsApi[];
}
/**
 * DLSS Model Preset Profile Overrides Value
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "DLSSModelPresetProfileValue".
 */
export interface DLSSModelPresetProfileValue {
    profileType: ExtendedDLSSModelPresetProfileType;
    useGlobal?: boolean;
}
/**
 * DLSS Neural Rendering Overrides Value
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "DLSSNRValue".
 */
export interface DLSSNRValue {
    enabled: ExtendedEnabledValue;
    modelOverride: ExtendedModelOverride;
    performanceModeOverride?: ExtendedPerformanceModeOverride;
    useGlobal?: boolean;
}
/**
 * AIDVC Value.missing 'useGlobal' means useGlobal=false. useGlobal must be always true, useGlobal with false is undefined behavior.
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "AIDVCValue".
 */
export interface AIDVCValue {
    enabled?: boolean;
    intensity?: number;
    saturation?: number;
    offlineSupported?: boolean;
    useGlobal?: boolean;
}
/**
 * AIHDR Value.missing 'useGlobal' means useGlobal=false. useGlobal must be always true, useGlobal with false is undefined behavior.
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "AIHDRValue".
 */
export interface AIHDRValue {
    enabled?: boolean;
    peakBrightness?: number;
    peakBrightnessMin?: number;
    peakBrightnessMax?: number;
    middleGrey?: number;
    saturation?: number;
    contrast?: number;
    useGlobal?: boolean;
}
/**
 * NIS2 Resolution
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ImageScalingResolution".
 */
export interface ImageScalingResolution {
    /**
     * Scaling factor
     */
    percent?: number;
    /**
     * Resolution string
     */
    resolution?: string;
}
/**
 * ImageScalingValue value.missing 'useGlobal' means useGlobal=false. useGlobal must be always true, useGlobal with false is undefined behavior.
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ImageScalingValue".
 */
export interface ImageScalingValue {
    enabled?: boolean;
    indicatorValue?: boolean;
    /**
     * Sharpness value
     */
    sharpen?: number;
    /**
     * true if hypersmapling resolutions are already created on system
     */
    hyperSamplingResolutionCreated?: boolean;
    selectedResolutionIndex?: number;
    /**
     * Array of resolution and scaling factor
     */
    resolutions?: ImageScalingResolution[];
    useGlobal?: boolean;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "BatteryBoostData".
 */
export interface BatteryBoostData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "WhisperModeData".
 */
export interface WhisperModeData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ImageScalingData".
 */
export interface ImageScalingData {
    SettingInfo?: ProfileSetting;
}
/**
 * PhysX GPU Name
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "PhysXGpu".
 */
export interface PhysXGpu {
    /**
     * PhysX Setting values
     */
    gpuName: string;
    /**
     * Dedicated PhysX GPU value
     */
    dedicatedPhysX: boolean;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "PhysXValue".
 */
export interface PhysXValue {
    /**
     * Array of physX processor
     */
    physXGpu: PhysXGpu[];
    /**
     * Recommended GPU String
     */
    recommendedGpu?: string;
    /**
     * PhysX indicator
     */
    physXIndicator?: boolean;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "PhysXData".
 */
export interface PhysXData {
    SettingInfo?: ProfileSetting;
}
/**
 * DSR Factor Information
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "DSRFactorInformation".
 */
export interface DSRFactorInformation {
    /**
     * DSR Factor Value
     */
    factorValue?: number;
    /**
     * DSR Factor Selected or not
     */
    isSelected?: boolean;
    /**
     * Is current DL DSR Factor or not
     */
    isDLDSRFactor?: boolean;
    /**
     * Hyper Sample Resolution string
     */
    resolution?: string;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "DSRFactorValue".
 */
export interface DSRFactorValue {
    /**
     * Smoothness value
     */
    smoothness?: number;
    /**
     * Array of factor information and resolution
     */
    factorInformation?: DSRFactorInformation[];
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "DSRFactorData".
 */
export interface DSRFactorData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "AIDVCData".
 */
export interface AIDVCData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "AIHDRData".
 */
export interface AIHDRData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "DLSSSRData".
 */
export interface DLSSSRData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "DLSSRRData".
 */
export interface DLSSRRData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "DLSSFGData".
 */
export interface DLSSFGData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "FGXData".
 */
export interface FGXData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "DLSSModelPresetProfileData".
 */
export interface DLSSModelPresetProfileData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "DLSSNRData".
 */
export interface DLSSNRData {
    SettingInfo?: ProfileSetting;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ProfileSettingsInfo".
 */
export interface ProfileSettingsInfo {
    CudaGpus?: CudaGpusData;
    CudaGpuOrdering?: CudaGpuOrderingData;
    VerticalSync?: VerticalSyncData;
    TextureFilteringTrilinear?: TextureFilteringTrilinearData;
    TexturefilteringAnisotropicFilterOpt?: TexturefilteringAnisotropicFilterOptData;
    TexturefilteringAnisotropicSampleOpt?: TexturefilteringAnisotropicSampleOptData;
    TripleBuffering?: TripleBufferingData;
    MultiFrameSampleAA?: MultiFrameSampleAAData;
    AntialiasingFXAA?: AntialiasingFXAAData;
    AntialiasingGammaCorrection?: AntialiasingGammaCorrectionData;
    GpuScaling?: GpuScalingData;
    ThreadedOptimization?: ThreadedOptimizationData;
    EnableOverlay?: EnableOverlayData;
    Exportedpixeltypes?: ExportedpixeltypesData;
    ShaderCache?: ShaderCacheData;
    PreCompileShader?: PreCompileShaderData;
    VirtualRealityPreRenderedFrames?: VirtualRealityPreRenderedFramesData;
    PreferredRefreshRate?: PreferredRefreshRateData;
    PowerManagementMode?: PowerManagementModeData;
    OpenGlVulkanPresentMethod?: OpenGlVulkanPresentMethodData;
    CudaSysmemFallbackPolicy?: CudaSysmemFallbackPolicyData;
    ResizableBar?: ResizableBarData;
    OpenGlGdiCompatibility?: OpenGlGdiCompatibilityData;
    AnisotropicFiltering?: AnisotropicFilteringData;
    TextureFilteringNegativeMethod?: TextureFilteringNegativeMethodData;
    TextureFilteringQuality?: TextureFilteringQualityData;
    OpenGLRenderingGPU?: OpenGLRenderingGPUData;
    ImageSharpening?: ImageSharpeningData;
    ImageSharpeningToggle?: ImageSharpeningToggleData;
    ImageSharpeningAllow?: ImageSharpeningAllowData;
    ImageSharpeningNoiseGrain?: ImageSharpeningNoiseGrainData;
    MaxFrameRate?: MaxFrameRateData;
    MaxFrameRateFPS?: MaxFrameRateFPSData;
    BackgroundAppMaxFrameRate?: BackgroundAppMaxFrameRateData;
    BackgroundAppMaxFrameRateFPS?: BackgroundAppMaxFrameRateFPSData;
    WhisperModeProgram?: WhisperModeProgramData;
    SilkSmoothness?: SilkSmoothnessData;
    LowLatencyMode?: LowLatencyModeData;
    VirtualRealityVrss?: VirtualRealityVrssData;
    MaxqDynamicBoost?: MaxqDynamicBoostData;
    AutoDisplaySwitching?: AutoDisplaySwitchingData;
    WhisperModeGlobal?: WhisperModeGlobalData;
    MonitorTechnology?: MonitorTechnologyData;
    PowerManagementPanel?: PowerManagementPanelData;
    StereoEnable?: StereoEnableData;
    StereoSwapEye?: StereoSwapEyeData;
    StereoDisplayMode?: StereoDisplayModeData;
    StereoSwapMode?: StereoSwapModeData;
    AntialiasingMode?: AntialiasingModeData;
    SLIMultiGPURenderingMode?: SLIMultiGPURenderingModeData;
    DeepColorFor3DApplications?: DeepColorFor3DApplicationsData;
    AntialiasingSetting?: AntialiasingSettingData;
    AntialiasingTransparency?: AntialiasingTransparencyData;
    BatteryBoost?: BatteryBoostData;
    WhisperMode?: WhisperModeData;
    ImageScaling?: ImageScalingData;
    DSRFactor?: DSRFactorData;
    PhysX?: PhysXData;
    AIDVC?: AIDVCData;
    AIHDR?: AIHDRData;
    DLSSSR?: DLSSSRData;
    DLSSRR?: DLSSRRData;
    DLSSFG?: DLSSFGData;
    DLSSMF?: DLSSFGData;
    FGX?: FGXData;
    DLSSModelPresetProfile?: DLSSModelPresetProfileData;
    DLSSNR?: DLSSNRData;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ProfileSettingValue".
 */
export interface ProfileSettingValue {
    SettingType?: ProfileSettingType;
    IntegerValue?: number;
    StringValue?: string;
    /**
     * Stringified Json
     */
    JsonStringValue?: string;
    IsUserModified?: number;
    IsDisabled?: boolean;
    /**
     * Error code when isDisabled is true.
     */
    errorCode?: number;
    /**
     * error constraint for hard and soft requirements
     */
    constraints?: ConstraintType[];
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ProfileSettingValueId".
 */
export interface ProfileSettingValueId {
    SettingId?: number;
    SettingType?: ProfileSettingType;
    IntegerValue?: number;
    StringValue?: string;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "SettingInfo".
 */
export interface SettingInfo {
    SettingEnum?: number;
    SettingValue?: ProfileSettingValue;
    SettingDefaultValue?: ProfileSettingValue;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "DrsApplication".
 */
export interface DrsApplication {
    /**
     * launcher name of application
     */
    launcherName?: string;
    /**
     * friendly name of application
     */
    friendlyName?: string;
    /**
     * name of application
     */
    appName?: string;
    /**
     * find file name of application
     */
    findFileName?: string;
    /**
     * true for metro application
     */
    isMetro?: boolean;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ProfileAndApps".
 */
export interface ProfileAndApps {
    /**
     * name of the profile
     */
    profileName?: string;
    /**
     * Array of applications, associated with a given profile
     */
    Apps?: DrsApplication[];
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GpuActivityTrayIconState".
 */
export interface GpuActivityTrayIconState {
    /**
     * Indicates if toggle is visible to user
     */
    isGpuActivityTrayIconSupported: boolean;
    /**
     * When false, user is not allowed to toggle
     */
    isToggleSupported: boolean;
    /**
     * Indicates if toggle state is on
     */
    isToggleOn: boolean;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GetProfileSettingsInfoParameters".
 */
export interface GetProfileSettingsInfoParameters {
    /**
     * clears the plugin cache for support state refresh
     */
    clearCache?: boolean;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GetProfileInfoParameters".
 */
export interface GetProfileInfoParameters {
    ProfileName?: string;
    ApplicationId?: number;
    CmsId?: number;
    /**
     * whether we need to requery the supportinfo
     */
    refreshSupportInfo?: boolean;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GetProfileInfoReturn".
 */
export interface GetProfileInfoReturn {
    profileSettingInfo?: SettingInfo[];
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GetProfileSettingValueParameters".
 */
export interface GetProfileSettingValueParameters {
    ProfileName?: string;
    ProfileSettingEnum?: number;
    ApplicationId?: number;
    CmsId?: number;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GetProfileSettingValueReturn".
 */
export interface GetProfileSettingValueReturn {
    SettingValue?: ProfileSettingValue;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GetProfileSettingDefaultValueParameters".
 */
export interface GetProfileSettingDefaultValueParameters {
    ProfileName?: string;
    ProfileSettingEnum?: number;
    ApplicationId?: number;
    CmsId?: number;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GetProfileSettingDefaultValueReturn".
 */
export interface GetProfileSettingDefaultValueReturn {
    SettingDefaultValue?: ProfileSettingValue;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GetProfileNameFromExeParameters".
 */
export interface GetProfileNameFromExeParameters {
    ExeName?: string;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GetProfileNameFromExeReturn".
 */
export interface GetProfileNameFromExeReturn {
    ProfileName?: string;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "SetProfileSettingValueParameters".
 */
export interface SetProfileSettingValueParameters {
    ProfileName?: string;
    ProfileSettingEnum?: number;
    ApplicationId?: number;
    CmsId?: number;
    SettingValue?: ProfileSettingValue;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GetProfileJsonStringSettingPossibleValuesParameters".
 */
export interface GetProfileJsonStringSettingPossibleValuesParameters {
    ProfileSettingEnum?: number;
    ApplicationId?: number;
    CmsId?: number;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GetProfileJsonStringSettingPossibleValuesReturn".
 */
export interface GetProfileJsonStringSettingPossibleValuesReturn {
    values?: string;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GetProfileStringSettingPossibleValuesParameters".
 */
export interface GetProfileStringSettingPossibleValuesParameters {
    ProfileSettingEnum?: number;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GetProfileStringSettingPossibleValuesReturn".
 */
export interface GetProfileStringSettingPossibleValuesReturn {
    values?: string[];
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GetProfileScalarSettingPossibleValuesParameters".
 */
export interface GetProfileScalarSettingPossibleValuesParameters {
    ProfileSettingEnum?: number;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GetProfileScalarSettingPossibleValuesReturn".
 */
export interface GetProfileScalarSettingPossibleValuesReturn {
    values?: number[];
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "RestoreDefaultForProfileParameters".
 */
export interface RestoreDefaultForProfileParameters {
    ProfileName?: string;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GetShaderCompilerTaskLastRunTimeReturn".
 */
export interface GetShaderCompilerTaskLastRunTimeReturn {
    /**
     * Last run time in YYYY-MM-DD HH:MM:SS format, or 'Never' if task hasn't run, or empty string on error
     */
    lastRunTime?: string;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GetProgramProfileNamesReturn".
 */
export interface GetProgramProfileNamesReturn {
    profileNames?: string[];
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GetProfilesAndApplicationsInfoReturn".
 */
export interface GetProfilesAndApplicationsInfoReturn {
    profilesAndApps?: ProfileAndApps[];
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GetGlobalProfileNamesReturn".
 */
export interface GetGlobalProfileNamesReturn {
    profileNames?: string[];
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "CreateNewProfileParameters".
 */
export interface CreateNewProfileParameters {
    ProfileName?: string;
    Applications?: string[];
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "DeleteProfileParameters".
 */
export interface DeleteProfileParameters {
    ProfileName?: string;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GetDynamicBoostReturn".
 */
export interface GetDynamicBoostReturn {
    isDynamicBoost?: boolean;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ToggleGpuActivityTrayIconParameters".
 */
export interface ToggleGpuActivityTrayIconParameters {
    /**
     * Desired GPU Activity tray icon visibility.
     */
    checked: boolean;
}
/**
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "PrecompilationStatusNotificationReturn".
 */
export interface PrecompilationStatusNotificationReturn {
    status: PrecompilationStatus;
}

/**
 * Defines possible profile setting types
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ProfileSettingType".
 */
export enum ProfileSettingType {
    type_invalid = -1,
    type_integer = 0,
    type_string = 1,
    type_boolean = 2,
    type_json_string = 3
}
/**
 * Hardware support flag
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "HwSupportType".
 */
export enum HwSupportType {
    UNKNOWN = 0,
    SUPPORTED = 1,
    UNSUPPORTED = 2
}
/**
 * constraint for hard and soft requirements
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ConstraintType".
 */
export enum ConstraintType {
    Unknown = 0,
    GpuUnsupported = 1,
    DriverUnsupported = 2,
    HardwareSchedulingUnavailable = 3,
    GraphicsApiUnsupported = 4,
    DenyListed = 5,
    x86Unsupported = 6,
    SRModelDenyListed = 7,
    RRModelDenyListed = 8,
    FGMultiFrameCountUnsupported = 9,
    FGUIRModelDriverUnsupported = 10,
    DynamicFGDriverUnsupported = 11,
    DynamicFGSLUnsupported = 12,
    DLSSPinnedSLVersionUnsupported = 13,
    DLSSNRDriverUnsupported = 14,
    DLSSNRGPUUnsupported = 15
}
/**
 * DLSS Overrides support states
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "DLSSSupportState".
 */
export enum DlssSupportState {
    ScanDetectSupported = 0,
    NGXDetectSupported = 1,
    ScanDetectUnknown = 2,
    NGXDetectUnknown = 3
}
/**
 * Graphics API
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "GraphicsApi".
 */
export enum GraphicsApi {
    Unknown = -1,
    OpenGL = 1,
    DX9 = 2,
    DX10 = 3,
    DX10_1 = 8,
    DX11 = 10,
    OpenCL = 64,
    DX12 = 128,
    Vulkan = 256
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "TextureFilteringTrilinearValue".
 */
export enum TextureFilteringTrilinearValue {
    NVCPLAPI_VALUE_TRILINEAR_OPT_ON = 0,
    NVCPLAPI_VALUE_TRILINEAR_OPT_OFF = 1
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "VerticalSyncValue".
 */
export enum VerticalSyncValue {
    NVCPLAPI_VALUE_VERTICAL_SYNC_APPCONTROLLED = 0,
    NVCPLAPI_VALUE_VERTICAL_SYNC_FORCEOFF = 1,
    NVCPLAPI_VALUE_VERTICAL_SYNC_FORCEON = 2,
    NVCPLAPI_VALUE_VERTICAL_SYNC_FORCEON_INTERVAL2 = 3,
    NVCPLAPI_VALUE_VERTICAL_SYNC_AUTO = 4,
    NVCPLAPI_VALUE_VERTICAL_SYNC_AUTO_INTERVAL2 = 5,
    NVCPLAPI_VALUE_VERTICAL_SYNC_SMOOTH = 6,
    NVCPLAPI_VALUE_VERTICAL_SYNC_VRR_ENABLE = 8,
    NVCPLAPI_VALUE_VERTICAL_SYNC_VRR_NONE = 9,
    NVCPLAPI_VALUE_VERTICAL_SYNC_VIRTUAL = 10
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ThreadedOptimizationValue".
 */
export enum ThreadedOptimizationValue {
    NVCPLAPI_VALUE_OGL_THREADING_OPTIMIZATION_AUTO = 0,
    NVCPLAPI_VALUE_OGL_THREADING_OPTIMIZATION_ON = 1,
    NVCPLAPI_VALUE_OGL_THREADING_OPTIMIZATION_OFF = 2
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "EnableOverlayValue".
 */
export enum EnableOverlayValue {
    NVCPLAPI_VALUE_OGL_OVERLAYSUPPORT_OFF = 0,
    NVCPLAPI_VALUE_OGL_OVERLAYSUPPORT_ON = 1
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ExportedpixeltypesValue".
 */
export enum ExportedpixeltypesValue {
    NVCPLAPI_VALUE_OGL_OVERLAY_PIXEL_NONE = 0,
    NVCPLAPI_VALUE_OGL_OVERLAY_PIXEL_CI = 1,
    NVCPLAPI_VALUE_OGL_OVERLAY_PIXEL_RGBA = 2,
    NVCPLAPI_VALUE_OGL_OVERLAY_PIXEL_CI_AND_RGBA = 3
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ShaderCacheValue".
 */
export enum ShaderCacheValue {
    NVAPPAPI_VALUE_SHADER_CACHE_SIZE_DISABLED = 0,
    NVAPPAPI_VALUE_SHADER_CACHE_SIZE_128 = 1,
    NVAPPAPI_VALUE_SHADER_CACHE_SIZE_256 = 2,
    NVAPPAPI_VALUE_SHADER_CACHE_SIZE_512 = 3,
    NVAPPAPI_VALUE_SHADER_CACHE_SIZE_1GB = 4,
    NVAPPAPI_VALUE_SHADER_CACHE_SIZE_5GB = 5,
    NVAPPAPI_VALUE_SHADER_CACHE_SIZE_10GB = 6,
    NVAPPAPI_VALUE_SHADER_CACHE_SIZE_100GB = 7,
    NVAPPAPI_VALUE_SHADER_CACHE_SIZE_Unlimited = 8,
    NVAPPAPI_VALUE_SHADER_CACHE_SIZE_DEFAULT = 9
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "PreCompileShaderValue".
 */
export enum PreCompileShaderValue {
    NVAPPAPI_VALUE_PRE_COMPILE_SHADER_OFF = 0,
    NVAPPAPI_VALUE_PRE_COMPILE_SHADER_SLOW = 1,
    NVAPPAPI_VALUE_PRE_COMPILE_SHADER_MEDIUM = 2,
    NVAPPAPI_VALUE_PRE_COMPILE_SHADER_FAST = 3
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "VirtualRealityPreRenderedFramesValue".
 */
export enum VirtualRealityPreRenderedFramesValue {
    NVCPLAPI_VALUE_MAX_VIRTUAL_REALITY_PRE_RENDERED_FRAMES_NONE = 0,
    NVCPLAPI_VALUE_MAX_VIRTUAL_REALITY_PRE_RENDERED_FRAMES_ONE = 1,
    NVCPLAPI_VALUE_MAX_VIRTUAL_REALITY_PRE_RENDERED_FRAMES_TWO = 2,
    NVCPLAPI_VALUE_MAX_VIRTUAL_REALITY_PRE_RENDERED_FRAMES_THREE = 3,
    NVCPLAPI_VALUE_MAX_VIRTUAL_REALITY_PRE_RENDERED_FRAMES_FOUR = 4
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "PreferredRefreshRateValue".
 */
export enum PreferredRefreshRateValue {
    NVCPLAPI_VALUE_PREFERRED_REFRATE_APP_CONTROL = 0,
    NVCPLAPI_VALUE_PREFERRED_REFRATE_OVERRIDE = 1
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "PowerManagementModeValue".
 */
export enum PowerManagementModeValue {
    NVCPLAPI_VALUE_POWER_MANAGEMENT_MODE_ADAPTIVE = 0,
    NVCPLAPI_VALUE_POWER_MANAGEMENT_MODE_MAX = 1,
    NVCPLAPI_VALUE_POWER_MANAGEMENT_MODE_DRIVER_CONTROLLED = 2,
    NVCPLAPI_VALUE_POWER_MANAGEMENT_MODE_PREFER_CONSISTENT_PERFORMANCE = 3,
    NVCPLAPI_VALUE_POWER_MANAGEMENT_MODE_OPTIMAL_POWER = 5
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "OpenGlVulkanPresentMethodValue".
 */
export enum OpenGlVulkanPresentMethodValue {
    NVCPLAPI_VALUE_OGL_VULKAN_PRESENT_METHOD_PREFER_DISABLED = 0,
    NVCPLAPI_VALUE_OGL_VULKAN_PRESENT_METHOD_PREFER_ENABLED = 1,
    NVCPLAPI_VALUE_OGL_VULKAN_PRESENT_METHOD_AUTO = 2
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "CudaSysmemFallbackPolicyValue".
 */
export enum CudaSysmemFallbackPolicyValue {
    NVCPLAPI_VALUE_CUDA_SYSMEM_FALLBACK_POLICY_DEFAULT_VAL = 0,
    NVCPLAPI_VALUE_CUDA_SYSMEM_FALLBACK_POLICY_DISALLOW_SYSMEM_FALLBACK_VAL = 1,
    NVCPLAPI_VALUE_CUDA_SYSMEM_FALLBACK_POLICY_ALLOW_SYSMEM_FALLBACK_VAL = 2
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ResizableBarValue".
 */
export enum ResizableBarValue {
    NVCPLAPI_VALUE_RESIZABLE_BAR_AUTO = 1,
    NVCPLAPI_VALUE_RESIZABLE_BAR_FORCE_DISABLE = 0,
    NVCPLAPI_VALUE_RESIZABLE_BAR_FORCE_ENABLE = 2
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "OpenGlGdiCompatibilityValue".
 */
export enum OpenGlGdiCompatibilityValue {
    NVCPLAPI_VALUE_OGL_GDI_COMPATIBILITY_PREFER_DISABLED = 0,
    NVCPLAPI_VALUE_OGL_GDI_COMPATIBILITY_PREFER_ENABLED = 1,
    NVCPLAPI_VALUE_OGL_GDI_COMPATIBILITY_AUTO = 2
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "AnisotropicFilteringValue".
 */
export enum AnisotropicFilteringValue {
    NVCPLAPI_VALUE_ANISOTROPIC_APP_CONTROLLED = 1048576,
    NVCPLAPI_VALUE_ANISOTROPIC_OFF = 1,
    NVCPLAPI_VALUE_ANISOTROPIC_2X = 2,
    NVCPLAPI_VALUE_ANISOTROPIC_4X = 4,
    NVCPLAPI_VALUE_ANISOTROPIC_8X = 8,
    NVCPLAPI_VALUE_ANISOTROPIC_16X = 16
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "TextureFilteringNegativeMethodValue".
 */
export enum TextureFilteringNegativeMethodValue {
    NVCPLAPI_VALUE_TEXTURE_FILTERING_LOD_NO_ALLOW = 0,
    NVCPLAPI_VALUE_TEXTURE_FILTERING_LOD_NO_CLAMP = 1
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "TextureFilteringQualityValue".
 */
export enum TextureFilteringQualityValue {
    NVCPLAPI_VALUE_D3D_PERFORMANCE_HIQUAL = 0,
    NVCPLAPI_VALUE_D3D_PERFORMANCE_QUAL = 1,
    NVCPLAPI_VALUE_D3D_PERFORMANCE_PERF = 2,
    NVCPLAPI_VALUE_D3D_PERFORMANCE_HIPERF = 3
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ImageSharpeningToggleValue".
 */
export enum ImageSharpeningToggleValue {
    NVCPLAPI_VALUE_IMAGE_SHARPENING_TOGGLE_DISABLED = 0,
    NVCPLAPI_VALUE_IMAGE_SHARPENING_TOGGLE_ENABLED = 1
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ImageSharpeningAllowValue".
 */
export enum ImageSharpeningAllowValue {
    NVCPLAPI_VALUE_SHARPENING_ALLOW_DISABLED = 0,
    NVCPLAPI_VALUE_SHARPENING_ALLOW_ENABLED = 15
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "WhisperModeProgramValue".
 */
export enum WhisperModeProgramValue {
    NVCPLAPI_VALUE_WHISPER_MODE_FPS_OFF = 0,
    NVCPLAPI_VALUE_WHISPER_MODE_FPS_ON = 1
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "SilkSmoothnessValue".
 */
export enum SilkSmoothnessValue {
    NVCPLAPI_VALUE_SILK_SMOOTHNESS_VALUE_LOW = 0,
    NVCPLAPI_VALUE_SILK_SMOOTHNESS_VALUE_MEDIUM = 1,
    NVCPLAPI_VALUE_SILK_SMOOTHNESS_VALUE_HIGH = 2,
    NVCPLAPI_VALUE_SILK_SMOOTHNESS_VALUE_ULTRA = 3,
    NVCPLAPI_VALUE_SILK_SMOOTHNESS_VALUE_OFF = 4
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "LowLatencyModeValue".
 */
export enum LowLatencyModeValue {
    NVCPLAPI_VALUE_LATENCY_MODE_BEST_PERFORMANCE = 0,
    NVCPLAPI_VALUE_LATENCY_MODE_LOW_LATENCY = 1,
    NVCPLAPI_VALUE_LATENCY_MODE_LOWEST_LATENCY = 2
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "VirtualRealityVrssValue".
 */
export enum VirtualRealityVrssValue {
    NVCPLAPI_VALUE_VR_AUTOVRS_OFF = 0,
    NVCPLAPI_VALUE_VR_AUTOVRS_FORCED = 1,
    NVCPLAPI_VALUE_VR_AUTOVRS_ADAPTIVE = 2
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "MaxqDynamicBoostValue".
 */
export enum MaxqDynamicBoostValue {
    NVCPLAPI_VALUE_AUTOFL_DB_OFF = 0,
    NVCPLAPI_VALUE_AUTOFL_DB_ON = 1
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "AutoDisplaySwitchingValue".
 */
export enum AutoDisplaySwitchingValue {
    NVCPLAPI_VALUE_AUTO_DISPLAYMUX_INDICATOR_OFF = 0,
    NVCPLAPI_VALUE_AUTO_DISPLAYMUX_INDICATOR_ON = 1
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "WhisperModeGlobalValue".
 */
export enum WhisperModeGlobalValue {
    NVCPLAPI_VALUE_WHISPER_MODE_ALLOW_DISABLED = 0,
    NVCPLAPI_VALUE_WHISPER_MODE_ALLOW_ENABLED = 1
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "MonitorTechnologyValue".
 */
export enum MonitorTechnologyValue {
    NVCPLAPI_VALUE_MT_GSYNC_ON = 0,
    NVCPLAPI_VALUE_MT_GSYNC_FORCE_OFF = 1,
    NVCPLAPI_VALUE_MT_VRR_OFF = 2,
    NVCPLAPI_VALUE_MT_ULMB_ON = 3,
    NVCPLAPI_VALUE_MT_FIXED_REFRESH = 4
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "PowerManagementPanelValue".
 */
export enum PowerManagementPanelValue {
    NVCPLAPI_VALUE_POWER_MANAGEMENT_PANEL_OFF = 0,
    NVCPLAPI_VALUE_POWER_MANAGEMENT_PANEL_SELF_REFRESH_MODE = 1
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "StereoEnableValue".
 */
export enum StereoEnableValue {
    NVCPLAPI_VALUE_ENABLE_STEREO_OFF = 0,
    NVCPLAPI_VALUE_ENABLE_STEREO_ON = 1
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "StereoDisplayModeValue".
 */
export enum StereoDisplayModeValue {
    NVAPPAPI_VALUE_STEREO_DISPLAY_MODE_DIN = 1,
    NVAPPAPI_VALUE_STEREO_DISPLAY_MODE_DIN_NV_IR = 2,
    NVAPPAPI_VALUE_STEREO_DISPLAY_MODE_DP_INBAND = 3,
    NVAPPAPI_VALUE_STEREO_DISPLAY_GENERIC = 4,
    NVAPPAPI_VALUE_STEREO_DISPLAY_GENERIC_NV_IR = 5,
    NVAPPAPI_VALUE_STEREO_DISPLAY_DDC_GLASSES = 6,
    NVAPPAPI_VALUE_STEREO_DISPLAY_NV_CLONE = 7,
    NVAPPAPI_VALUE_STEREO_DISPLAY_NV_CLONE_DLP = 8,
    NVAPPAPI_VALUE_STEREO_DISPLAY_BLUELINE = 9,
    NVAPPAPI_VALUE_STEREO_DISPLAY_VERTICAL_INTERLACE = 10,
    NVAPPAPI_VALUE_STEREO_DISPLAY_COLOR_INTERLEAVE = 11,
    NVAPPAPI_VALUE_STEREO_DISPLAY_HORIZONTAL_INTERLACE = 12,
    NVAPPAPI_VALUE_STEREO_DISPLAY_SUBFIELD = 13,
    NVAPPAPI_VALUE_STEREO_DISPLAY_SIDEFIELD = 14,
    NVAPPAPI_VALUE_STEREO_DISPLAY_SEEFRONT = 15,
    NVAPPAPI_VALUE_STEREO_DISPLAY_3D_DLP = 16,
    NVAPPAPI_VALUE_STEREO_DISPLAY_3D_DLP_NV_IR = 17,
    NVAPPAPI_VALUE_STEREO_DISPLAY_3D_DLP_INV = 18,
    NVAPPAPI_VALUE_STEREO_DISPLAY_3D_DLP_INV_NV_IR = 19,
    NVAPPAPI_VALUE_STEREO_DISPLAY_TRIDELITY_SL_SV = 20,
    NVAPPAPI_VALUE_STEREO_DISPLAY_TRIDELITY_MV = 21,
    NVAPPAPI_VALUE_STEREO_DISPLAY_PLANAR_MIRROR = 22
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "StereoSwapEyeValue".
 */
export enum StereoSwapEyeValue {
    NVCPLAPI_VALUE_ENABLE_OGL_STEREO_SWAP_EYES_OFF = 0,
    NVCPLAPI_VALUE_ENABLE_OGL_STEREO_SWAP_EYES_ON = 1
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "StereoSwapModeValue".
 */
export enum StereoSwapModeValue {
    NVCPLAPI_VALUE_STEREO_SWAP_APPLICATION_CONTROL = 0,
    NVCPLAPI_VALUE_STEREO_SWAP_PER_EYE = 1,
    NVCPLAPI_VALUE_STEREO_SWAP_PER_EYE_PAIR = 2
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "AntialiasingModeValue".
 */
export enum AntialiasingModeValue {
    NVCPLAPI_VALUE_AA_APPCONTROL_MODE_OFF = 0,
    NVCPLAPI_VALUE_AA_APPCONTROL_MODE_ON = 1,
    NVCPLAPI_VALUE_AA_APPCONTROL_MODE_ENHANCE = 2,
    NVCPLAPI_VALUE_AA_APPCONTROL_MODE_FORCE_OFF = 3
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "SLIMultiGPURenderingModeValue".
 */
export enum SliMultiGpuRenderingModeValue {
    NVCPLAPI_VALUE_SLI_MGPU_AUTORENDER = 0,
    NVCPLAPI_VALUE_SLI_MGPU_FORCE_SINGLE = 4,
    NVCPLAPI_VALUE_SLI_MGPU_FORCE_2_AFR = 3,
    NVCPLAPI_VALUE_SLI_MGPU_FORCE_2_AFR2 = 61443
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "DeepColorFor3DApplicationsValue".
 */
export enum DeepColorFor3DApplicationsValue {
    NVCPLAPI_VALUE_OGL_DEEP_COLOR_3D_DISABLE = 0,
    NVCPLAPI_VALUE_OGL_DEEP_COLOR_3D_ENABLE = 1
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "AntialiasingSettingValue".
 */
export enum AntialiasingSettingValue {
    NVCPLAPI_VALUE_ANTI_ALIASING_METHOD_NONE = 0,
    NVCPLAPI_VALUE_ANTI_ALIASING_METHOD_APP_CONTROLLED = 1048576,
    NVCPLAPI_VALUE_ANTI_ALIASING_METHOD_MULTISAMPLE_2X_DIAGONAL = 14,
    NVCPLAPI_VALUE_ANTI_ALIASING_METHOD_MULTISAMPLE_4X = 16,
    NVCPLAPI_VALUE_ANTI_ALIASING_METHOD_MIXEDSAMPLE_8SX = 24,
    NVCPLAPI_VALUE_ANTI_ALIASING_METHOD_MULTISAMPLE_8X = 25,
    NVCPLAPI_VALUE_ANTI_ALIASING_METHOD_MIXEDSAMPLE_16X = 26,
    NVCPLAPI_VALUE_ANTI_ALIASING_METHOD_MIXEDSAMPLE_32X = 41,
    NVCPLAPI_VALUE_ANTI_ALIASING_METHOD_MIXEDSAMPLE_64X = 42,
    NVCPLAPI_VALUE_ANTI_ALIASING_METHOD_MIXEDSAMPLE_128X = 43
}
/**
 * setting currentValue
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "AntialiasingTransparencyValue".
 */
export enum AntialiasingTransparencyValue {
    NVCPLAPI_VALUE_TRANSPARENCY_ANTI_ALIASING_OFF = 0,
    NVCPLAPI_VALUE_TRANSPARENCY_ANTI_ALIASING_MULTI_SAMPLING = 3,
    NVCPLAPI_VALUE_TRANSPARENCY_ANTI_ALIASING_SUPER_SAMPLING = 5,
    NVCPLAPI_VALUE_TRANSPARENCY_ANTI_ALIASING_1X = 1,
    NVCPLAPI_VALUE_TRANSPARENCY_ANTI_ALIASING_2X = 2,
    NVCPLAPI_VALUE_TRANSPARENCY_ANTI_ALIASING_4X = 4,
    NVCPLAPI_VALUE_TRANSPARENCY_ANTI_ALIASING_8X = 8
}
/**
 * BatteryBoost Version
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "BatteryBoostVersionEnum".
 */
export enum BatteryBoostVersionEnum {
    V1 = 1,
    V2 = 2
}
/**
 * WhisperMode Version
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "WhisperModeVersionEnum".
 */
export enum WhisperModeVersionEnum {
    V1 = 1,
    V2 = 2
}
/**
 * Fan volume - V1: enum, V2: NA
 */
export enum FanVolume {
    QUIETER = 1,
    QUIET = 2,
    BALANCED = 3
}
/**
 * DLSS Performance Mode Overrides
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "PerformanceModeOverrideEnum".
 */
export enum PerformanceModeOverrideEnum {
    Default = 3,
    Performance = 0,
    Balanced = 1,
    Quality = 2,
    UltraPerformance = 5,
    Dlaa = 4,
    Custom = 6
}
/**
 * DLSS Model Overrides. Latest value provided by NVAPI
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "ModelOverrideEnum".
 */
export enum ModelOverrideEnum {
    Default = 0,
    PresetA = 1,
    PresetB = 2,
    PresetC = 3,
    PresetD = 4,
    PresetE = 5,
    PresetF = 6,
    PresetJ = 10,
    PresetK = 11,
    PresetL = 12,
    PresetM = 13,
    PresetN = 14,
    PresetO = 15,
    Latest = 16777215
}
/**
 * DLSS Model Overrides for FG UIR Feature
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "FGUIRModelOverrideEnum".
 */
export enum FguirModelOverrideEnum {
    OFF = 0,
    PresetA = 1,
    PresetB = 2,
    PresetC = 3,
    Latest = 16777214
}
/**
 * DLSS MultiFrame Count
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "MultiFrameEnum".
 */
export enum MultiFrameEnum {
    OFF = 0,
    VALUE_3X = 2,
    VALUE_4X = 3,
    VALUE_5X = 4,
    VALUE_6X = 5,
    VALUE_7X = 6,
    VALUE_8X = 7
}
/**
 * DLSS Dynamic FG Mode
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "DynamicFGModeEnum".
 */
export enum DynamicFgModeEnum {
    OFF = 0,
    FIXED = 2,
    DYNAMIC = 4
}
/**
 * DLSS Model Preset Profile Type
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "DLSSModelPresetProfileTypeEnum".
 */
export enum DlssModelPresetProfileTypeEnum {
    Default = 0,
    Latest = 1,
    Custom = 2
}
/**
 * Precompilation status enum
 *
 * This interface was referenced by `NvCplplugin`'s JSON-Schema
 * via the `definition` "PrecompilationStatus".
 */
export enum PrecompilationStatus {
    PreCompilationInProgress = 0,
    PreCompilationComplete = 1
}


}
